import { render, staticRenderFns } from "./marketing_record.vue?vue&type=template&id=5515da68&scoped=true"
import script from "./marketing_record.vue?vue&type=script&lang=js"
export * from "./marketing_record.vue?vue&type=script&lang=js"
import style0 from "./marketing_record.vue?vue&type=style&index=0&id=5515da68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5515da68",
  null
  
)

export default component.exports